/**
 * Org Param Group: Produção ('production')
 *
 * Operational switches that tighten the flexible production-entry contract
 * (spec 0040 §3 / request 0175), the production→stock integration (F4 / 0179),
 * `requireRun` for pointing against a started execution (0183),
 * `requireStopReason` for classifying idle time (0186), and
 * `defaultWorkCalendarId` as the last step of the work-calendar cascade (0189).
 * Defaults keep the base livre: OP-only entries and entries without a step or
 * run are valid until an org-admin turns a switch on. Stock posting is on by default;
 * a failed integration stays pending (does not block the entry) unless the
 * org chooses `block`.
 *
 * Deferred candidates in spec §3 are intentionally omitted.
 */
const STOCK_DEPENDENTS = [
    'outputStockLocationId',
    'materialsStockLocationId',
    'outputFailurePolicy',
    'materialsFailurePolicy',
];
const parameters = [
    {
        key: 'requireTicket',
        label: 'Exigir talão no apontamento',
        type: 'boolean',
        scope: 'module',
        default: false,
        required: false,
        orgEditable: true,
    },
    {
        key: 'requireStep',
        label: 'Exigir etapa no apontamento',
        type: 'boolean',
        scope: 'module',
        default: false,
        required: false,
        orgEditable: true,
    },
    {
        key: 'requireRun',
        label: 'Exigir execução iniciada no apontamento',
        type: 'boolean',
        scope: 'module',
        default: false,
        required: false,
        orgEditable: true,
    },
    {
        key: 'requireStopReason',
        label: 'Exigir motivo na parada',
        type: 'boolean',
        scope: 'module',
        default: true,
        required: false,
        orgEditable: true,
    },
    {
        key: 'postToStock',
        label: 'Integrar apontamento ao estoque',
        type: 'boolean',
        scope: 'module',
        default: true,
        required: false,
        orgEditable: true,
    },
    {
        key: 'backflushMaterials',
        label: 'Consumo automático de insumos',
        type: 'boolean',
        scope: 'module',
        default: true,
        required: false,
        orgEditable: true,
    },
    {
        key: 'outputStockLocationId',
        label: 'Local padrão da entrada do PA',
        type: 'reference',
        scope: 'module',
        referenceEntity: 'StockLocation',
        displayField: 'description',
        default: null,
        required: false,
        orgEditable: true,
    },
    {
        key: 'materialsStockLocationId',
        label: 'Local padrão do consumo de insumos',
        type: 'reference',
        scope: 'module',
        referenceEntity: 'StockLocation',
        displayField: 'description',
        default: null,
        required: false,
        orgEditable: true,
    },
    {
        key: 'outputFailurePolicy',
        label: 'Falha na entrada do PA',
        type: 'enum',
        scope: 'module',
        options: ['pending', 'block'],
        default: 'pending',
        required: false,
        orgEditable: true,
    },
    {
        key: 'materialsFailurePolicy',
        label: 'Falha no consumo de insumos',
        type: 'enum',
        scope: 'module',
        options: ['pending', 'block'],
        default: 'pending',
        required: false,
        orgEditable: true,
    },
    {
        key: 'defaultWorkCalendarId',
        label: 'Calendário de trabalho padrão',
        type: 'reference',
        scope: 'module',
        referenceEntity: 'WorkCalendar',
        displayField: 'description',
        default: null,
        required: false,
        orgEditable: true,
    },
];
export const productionOrgParamGroup = {
    key: 'production',
    label: 'Produção',
    version: 6,
    parameters,
    rules: {
        evaluate(values) {
            if (values['postToStock'] === true) {
                return { disabled: {}, reasons: {} };
            }
            const disabled = {};
            const reasons = {};
            for (const key of STOCK_DEPENDENTS) {
                disabled[key] = true;
                reasons[key] = 'Requer integração com estoque';
            }
            return { disabled, reasons };
        },
        validate() {
            return [];
        },
        coerce() {
            return {};
        },
    },
};
//# sourceMappingURL=production.orgParamGroup.js.map